import {MITTWALD_API, Schemas} from "../middleware/MittwaldApi";
import * as ActionTypes from "../constants/ActionTypes";
import {queryBearerToken} from "./UserAuthentication";

const fetchCustomerResellers = (bearer, customerNumber) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.RESELLERS_REQUEST, ActionTypes.RESELLERS_SUCCESS, ActionTypes.RESELLERS_FAILURE],
        endpoint: `customers/${customerNumber}/resellers`,
        schema: Schemas.RESELLERS,
        bearer: bearer,
        method: 'GET',
        postData: {}
    }
})


export const queryCustomerResellers = (customerNumber) => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchCustomerResellers(getState().token.bearer, customerNumber))
    })
}


/** WEBPACK FOOTER **
 ** ./src/actions/Resellers.js
 **/